import createDuck from '../lib/MetagnosticDuck'
import { getSupplier, getSuppliers } from '../lib/APIClient'


const defaultTemplate = `Hola,

Te solicitamos una reserva a nombre de $Cliente en $Actividad, el día $Fecha a las $Hora, para $Personas personas.

Muchas gracias,
`

const emptySupplier = {
  _id: "",
  name: "",
  category: null,
  notes : "",
  contactPerson: "",
  phoneNumber: "",
  email: "",
  socialReason: "",
  cif : "",
  accountNumber: "",
  bankDescription: "",
  reservationEmailTemplate: defaultTemplate
}

/**
 *
 */

const duck = createDuck(
  "SUPPLIERS",
  getSupplier,
  getSuppliers,
  { },
  emptySupplier,
  null,
  {  }
)

export const createSupplier = duck.actions.createDoc
export const receiveSuppliers = duck.actions.receiveCollection
export const receiveSupplier = duck.actions.receiveDoc
export const removeSupplier = duck.actions.removeDoc
export const fetchSuppliers = duck.actions.fetchCollection
export const updateSupplier = duck.actions.updateDoc

export default duck
